import React, { useEffect, useState } from 'react';
import {
  Box, Paper, Typography, Stack, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TablePagination, Chip, Button, TextField, Select,
  MenuItem, FormControl, InputLabel, Dialog, DialogTitle, DialogContent,
  DialogActions
} from '@mui/material';
import { bugTrAPI, merchantAPI } from '../../Api';

const statusOptions = [
  { value: '', label: 'Все' },
  { value: 'in_progress', label: 'В работе' },
  { value: 'done', label: 'Выполнен' },
];

export default function BugTRList() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [filters, setFilters] = useState({ status: '', merchant: '' });
  const [merchants, setMerchants] = useState([]);
  const [selected, setSelected] = useState(null);
  const [answer, setAnswer] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    merchantAPI.getMerchant().then(res => setMerchants(res.data?.data || [])).catch(() => setMerchants([]));
  }, []);

  const fetchList = async () => {
    try {
      const res = await bugTrAPI.list({
        page: page + 1,
        limit: rowsPerPage,
        status: filters.status || undefined,
        merchant: filters.merchant || undefined,
      });
      setItems(res.data.data || []);
      setTotal(res.data.total || 0);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => { fetchList(); }, [filters, page, rowsPerPage]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setPage(0);
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const openDetails = (item) => {
    setSelected(item);
    setAnswer(item.ask || '');
    setStatus(item.status || 'in_progress');
  };

  const saveUpdate = async () => {
    if (!selected) return;
    try {
      await bugTrAPI.update(selected._id, { status, ask: answer });
      setSelected(null);
      fetchList();
    } catch (e) {
      console.error(e);
      alert('Не удалось сохранить');
    }
  };

  return (
    <Box sx={{ mt: 4, p: 3, bgcolor: '#fff', borderRadius: 2, boxShadow: 3 }}>
      <Typography variant="h5" align="center" gutterBottom sx={{ mb: 2 }}>
        Багтрекер мерчантов
      </Typography>

      <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel>Статус</InputLabel>
            <Select name="status" value={filters.status} label="Статус" onChange={handleFilterChange}>
              {statusOptions.map(s => (
                <MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 220 }}>
            <InputLabel>Мерчант</InputLabel>
            <Select name="merchant" value={filters.merchant} label="Мерчант" onChange={handleFilterChange}>
              <MenuItem value="">Все</MenuItem>
              {merchants.map(m => <MenuItem key={m._id} value={m._id}>{m.name}</MenuItem>)}
            </Select>
          </FormControl>
        </Stack>
      </Paper>

      <TableContainer component={Paper} elevation={1}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Мерчант</TableCell>
              <TableCell>Название</TableCell>
              <TableCell>Описание</TableCell>
              <TableCell>Статус</TableCell>
              <TableCell align="center">Действия</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(item => (
              <TableRow key={item._id} hover sx={{ cursor: 'pointer' }} onClick={() => openDetails(item)}>
                <TableCell>{item.merchant_id?.name || '-'}</TableCell>
                <TableCell>{item.name}</TableCell>
                <TableCell>{item.description || '-'}</TableCell>
                <TableCell>
                  <Chip size="small" color={item.status === 'done' ? 'success' : 'warning'} label={item.status === 'done' ? 'Выполнен' : 'В работе'} />
                </TableCell>
                <TableCell align="center">
                  <Button size="small" variant="outlined" onClick={(e) => { e.stopPropagation(); openDetails(item); }}>Открыть</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={total}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
      />

      <Dialog open={Boolean(selected)} onClose={() => setSelected(null)} fullWidth maxWidth="sm">
        <DialogTitle>Замечание: {selected?.name}</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            <Typography><strong>Мерчант:</strong> {selected?.merchant_id?.name}</Typography>
            <Typography><strong>Описание:</strong> {selected?.description || '-'}</Typography>
            <FormControl size="small" fullWidth>
              <InputLabel>Статус</InputLabel>
              <Select value={status} label="Статус" onChange={(e) => setStatus(e.target.value)}>
                <MenuItem value={'in_progress'}>В работе</MenuItem>
                <MenuItem value={'done'}>Выполнен</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Ответ по заявке"
              multiline
              minRows={3}
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSelected(null)}>Отмена</Button>
          <Button variant="contained" onClick={saveUpdate}>Сохранить</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
